import { render, staticRenderFns } from "./MainTableComponent.vue?vue&type=template&id=5d4ece29"
import script from "./MainTableComponent.vue?vue&type=script&lang=js"
export * from "./MainTableComponent.vue?vue&type=script&lang=js"
import style0 from "./MainTableComponent.vue?vue&type=style&index=0&id=5d4ece29&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports